import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

interface DialogData {
    customColumns: string[];
    maxColumns: number;
    defaultEmpty: boolean;
}

@Component({
    selector: "customize-search-columns-modal",
    template: `
        <span mat-dialog-title>
            {{ 'SEARCH_CUSTOMIZE_COLUMNS' | localize }}
        </span>
        <mat-dialog-content>
            <article>
                <section>
                    <customize-search-columns [customColumns]="customColumns"
                                              [maxColumns]="data.maxColumns"
                                              (columnsUpdated)="onColumnUpdate($event)"
                                              [defaultEmpty]="data.defaultEmpty">
                    </customize-search-columns>
                </section>
            </article>
        </mat-dialog-content>
        <mat-dialog-actions>
            <modal-buttons (onCancel)="onCancel()"
                           (onSave)="onSave()">
            </modal-buttons>
        </mat-dialog-actions>
    `,
})
export class CustomizeSearchColumnsModalComponent {

    customColumns: string[];

    constructor(private dialogRef: MatDialogRef<CustomizeSearchColumnsModalComponent>,
                @Inject(MAT_DIALOG_DATA) public data: DialogData) {
        this.customColumns = [...data.customColumns];
    }

    onSave(): void {
        this.dialogRef.close(this.customColumns);
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onColumnUpdate(customColumns: string[]) {
        this.customColumns = customColumns;
    }
}
